import { useOpenTiptapSelectionPopup } from '../../popup/useOpenTiptapSelectionPopup';

export const useOpenBoardLinkPopup = (): (() => void) => useOpenTiptapSelectionPopup('boardLink');
